var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import * as rawJSONSchemaModuleSurgeryGeneral from '../../schemas/module-surgery-general.json';
var ModuleValueSurgeryGeneral = (function (_super) {
    __extends(ModuleValueSurgeryGeneral, _super);
    function ModuleValueSurgeryGeneral() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueSurgeryGeneral;
}(ModuleValueGeneral));
var SchemaModuleSurgeryGeneral = (function (_super) {
    __extends(SchemaModuleSurgeryGeneral, _super);
    function SchemaModuleSurgeryGeneral() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleSurgeryGeneral);
        return _this;
    }
    SchemaModuleSurgeryGeneral.prototype.hook = function (form) {
        _super.prototype.hook.call(this, form);
    };
    SchemaModuleSurgeryGeneral.prototype.setupValidators = function () {
        _super.prototype.setupValidators.call(this);
        this.validatorDateComparison('date_of_surgery', 'date_of_birth', '>');
        this.validatorDate('date_of_birth', (new Date()), '<=', function (v) { return new Date(v); });
    };
    return SchemaModuleSurgeryGeneral;
}(SchemaModuleGeneral));
export { SchemaModuleSurgeryGeneral };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-surgery-general.ts.pre-build-optimizer.js